import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const AddAllergyDialog = ({ open, onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    substance: '',
    reaction: '',
    severity: '',
    date_noted: new Date().toISOString().split('T')[0],
    notes: '',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await onAdd({
        ...formData,
        severity: formData.severity || undefined,
        notes: formData.notes || undefined,
        source_type: 'manual',
      });

      setFormData({
        substance: '',
        reaction: '',
        severity: '',
        date_noted: new Date().toISOString().split('T')[0],
        notes: '',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Add Allergy</DialogTitle>
          <DialogDescription>Record an allergy or adverse reaction</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="substance">Substance *</Label>
              <Input id="substance" placeholder="e.g., Penicillin, Peanuts" value={formData.substance} onChange={(e) => setFormData({ ...formData, substance: e.target.value })} required />
            </div>

            <div className="grid gap-2">
              <Label htmlFor="reaction">Reaction Description *</Label>
              <Textarea id="reaction" placeholder="Describe the reaction..." value={formData.reaction} onChange={(e) => setFormData({ ...formData, reaction: e.target.value })} rows={3} required />
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="grid gap-2">
                <Label htmlFor="severity">Severity</Label>
                <Select value={formData.severity} onValueChange={(value) => setFormData({ ...formData, severity: value })}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select..." />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="mild">Mild</SelectItem>
                    <SelectItem value="moderate">Moderate</SelectItem>
                    <SelectItem value="severe">Severe</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="grid gap-2">
                <Label htmlFor="date_noted">Date First Noted *</Label>
                <Input id="date_noted" type="date" value={formData.date_noted} onChange={(e) => setFormData({ ...formData, date_noted: e.target.value })} required />
              </div>
            </div>

            <div className="grid gap-2">
              <Label htmlFor="notes">Additional Notes</Label>
              <Textarea id="notes" value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} rows={2} />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={loading} className="bg-red-100 hover:bg-red-200 text-red-900">
              {loading ? 'Adding...' : 'Add Allergy'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddAllergyDialog;